import { observable, action, computed, runInAction } from "mobx";
import moment from "moment";

const IS_BIRD_APP = process.env.REACT_APP_ENV === "bird";

export default class CreateFrameworkProjectStore {

  frameworkTypes = ["REF", "NREF", "PREF"];

  @observable createFrameworkProjectModalVisible = false;

  @observable createFrameworkProjectModalData = {
    project: {
      mid: "",
      name: "",
      finalizationDate: moment(new Date()).format("YYYY-MM-DD"),
      projectType: "FRAMEWORK",
      projectOwners: [],
      description: "",
      isFastTrack: false,
      areBusinessConstraintsDisabled: false,
    },
    frameworkToBeCreated: {
      code: "",
      description: "",
      name: "",
      frameworkType: null,
      reportingPopulation: "",
      otherLinks: "",
      orderNo: "",
    },
  }

  @observable selectedFrameworks = [];
  @observable listOfFrameworksToBeCreated = [];

  @observable arr_all_Frameworks = [];
  @observable arr_maintenanceAgencies = [];

  @observable arr_ma_projects = [];

  @observable
  obj_all_Frameworks = {
    type: "",
    filter: {},
    results: []
  };

  constructor(http, maintenanceAgencyStore) {
    this.http = http;
    this.maintenanceAgencyStore = maintenanceAgencyStore;
    this.activate_createFramStore();
  }

  @action
  activate_createFramStore = () => {
    this.helper_fetch_all_ma();
    this.helper_fetch_all_frameworks();
  };

  @action
  helper_fetch_all_ma = () => {
    if(IS_BIRD_APP) return;
    
    this.http.service_fetch_ALLMA().then(
      action(data => {
        try {
          this.arr_maintenanceAgencies = data.maintenanceAgencies;
        } catch (err) {
          console.error(err.message);
        }
      })
    );
  };

  @action
  helper_fetch_all_frameworks = () => {
    if(IS_BIRD_APP) return;
    
    try {
      this.arr_all_Frameworks = [];
      this.http.service_query_all_Frameworks().then(
        action(data => {
          if (data && data.results) {
            this.arr_all_Frameworks = data.results;
          }
        })
      );
    } catch (error) {
      console.log(error.message);
    }
  };

  @action
  handleCreateFrameworkProjectModalDataChange = (input_value, input_name) => {
    switch (input_name) {
      case "project.mid":
        this.createFrameworkProjectModalData.project.mid = input_value;
        break;
      case "project.name":
        this.createFrameworkProjectModalData.project.name = input_value;
        break;
      case "project.description":
        this.createFrameworkProjectModalData.project.description = input_value;
        break;
      case "project.finalizationDate":
        const isoDate = input_value.toISOString().split("T")[0];
        const dateInProperFormat = moment(isoDate).format("YYYY-MM-DD");
        this.createFrameworkProjectModalData.project.finalizationDate = dateInProperFormat;
        break;
      case "project.projectOwners":
        this.createFrameworkProjectModalData.project.projectOwners = input_value;
        break;
      case "project.isFastTrack":
        this.createFrameworkProjectModalData.project.isFastTrack = !this.createFrameworkProjectModalData.project.isFastTrack;
        break;
      case "project.areBusinessConstraintsDisabled":
        this.createFrameworkProjectModalData.project.areBusinessConstraintsDisabled = !this.createFrameworkProjectModalData.project.areBusinessConstraintsDisabled;
        break;
      case "frameworkToBeUsed":
        this.createFrameworkProjectModalData.frameworkToBeUsed = {
          tid: input_value
        };
        break;
      case "frameworkToBeCreated.code":
        this.createFrameworkProjectModalData.frameworkToBeCreated.code = input_value;
        break;
      case "frameworkToBeCreated.name":
        this.createFrameworkProjectModalData.frameworkToBeCreated.name = input_value;
        break;
      case "frameworkToBeCreated.description":
        this.createFrameworkProjectModalData.frameworkToBeCreated.description = input_value;
        break;
      case "frameworkToBeCreated.frameworkType":
        this.createFrameworkProjectModalData.frameworkToBeCreated.frameworkType = input_value;
        break;
      case "frameworkToBeCreated.reportingPopulation":
        this.createFrameworkProjectModalData.frameworkToBeCreated.reportingPopulation = input_value;
        break;
      case "frameworkToBeCreated.otherLinks":
        this.createFrameworkProjectModalData.frameworkToBeCreated.otherLinks = input_value;
        break;
      case "frameworkToBeCreated.orderNo":
        this.createFrameworkProjectModalData.frameworkToBeCreated.orderNo = input_value;
        break;
      default:
        break;
    }
  };

  @action
  sendCreateFrameworkRequest = () => {
    if(IS_BIRD_APP) return;
    
    const jsonToSend = this.createJson();
    runInAction(() => {
      this.http.func_sendGeneralMessage(jsonToSend, response => {
        this.o_alert_data = response;
      });
    });
  };

  createJson = () => {
    const json = {
      actionType: "CreateProject",
      project: {
        mid: this.createFrameworkProjectModalData.project.mid,
        name: this.createFrameworkProjectModalData.project.name,
        finalizationDate: this.createFrameworkProjectModalData.project.finalizationDate,
        projectType: "FRAMEWORK",
        description: this.createFrameworkProjectModalData.project.description,
        isFastTrack: this.createFrameworkProjectModalData.project.isFastTrack,
        areBusinessConstraintsDisabled: this.createFrameworkProjectModalData.project.areBusinessConstraintsDisabled,
      },
      projectOwners: this.createFrameworkProjectModalData.project.projectOwners
    };

    const frameworksToBeCreatedExist = this.listOfFrameworksToBeCreated.length > 0;
    const selectedFrameworksExist = this.selectedFrameworks.length > 0;

    if ( frameworksToBeCreatedExist && !selectedFrameworksExist ) {
      json.frameworksToBeCreated = this.listOfFrameworksToBeCreated;
    } else if ( !frameworksToBeCreatedExist && selectedFrameworksExist ) {
      json.frameworksToBeUsed = this.selectedFrameworks.map(framework => ({"tid" : framework}));
    } else if ( frameworksToBeCreatedExist && selectedFrameworksExist ) {
      json.frameworksToBeCreated = this.listOfFrameworksToBeCreated;
      json.frameworksToBeUsed = this.selectedFrameworks.map(framework => ({"tid" : framework}));
    }

    return json;
  }

  @computed
  get getFrameworksInSelectedMaintenanceAgency() {
    return this.arr_all_Frameworks.filter(
      framework => framework.mid === this.createFrameworkProjectModalData.project.mid).map(
        framework => {
          return {
            label: framework.name,
            value: framework.tid
          }
        }
      );
  }

  @computed
  get getFrameworksTypes() {
    return this.frameworkTypes.map(type => {
      return {
        label: type,
        value: type
      }
    });
  }

  @computed
  get doesProjectNameAlreadyExistInSelectedMaintenanceAgency() {
    const selectedMaintenanceAgencyItem = this.arr_maintenanceAgencies.filter(maItem => 
      maItem.maintenanceAgency.tid === this.createFrameworkProjectModalData.project.mid
    );
    if(selectedMaintenanceAgencyItem.length === 0) {
      return false;
    }
    const projectItemsWithSameProjectName = selectedMaintenanceAgencyItem[0].projects.filter(
      projectItem => projectItem.project.name.toLowerCase() === this.createFrameworkProjectModalData.project.name.toLowerCase()
    );
    
    return projectItemsWithSameProjectName.length > 0;
  };

  @computed
  get doesFrameworkNameAlreadyExist() {
    const filteredFrameworks = this.arr_all_Frameworks.filter(
      item => item.name.toLowerCase() === this.createFrameworkProjectModalData.frameworkToBeCreated.name.toLowerCase()
    );
    const filteredNewFrameworks = this.listOfFrameworksToBeCreated.filter(
      item => item.name.toLowerCase() === this.createFrameworkProjectModalData.frameworkToBeCreated.name.toLowerCase()
    );

    return filteredFrameworks.length > 0 || filteredNewFrameworks.length > 0;
  };

  @computed
  get doesFrameworkCodeAlreadyExist() {
      const filteredFrameworks = this.arr_all_Frameworks.filter(
        item => item.code.toLowerCase() === this.createFrameworkProjectModalData.frameworkToBeCreated.code.toLowerCase()
      );
      const filteredNewFrameworks = this.listOfFrameworksToBeCreated.filter(
        item => item.code.toLowerCase() === this.createFrameworkProjectModalData.frameworkToBeCreated.code.toLowerCase()
      );

      return filteredFrameworks.length > 0 || filteredNewFrameworks.length > 0;
  };

  @action
  toggleCreateFrameworkProjectModalVisibility = () => {
    this.resetCreateFrameworkProjectModalData();
    this.createFrameworkProjectModalVisible = !this.createFrameworkProjectModalVisible;
  }

  @action
  resetCreateFrameworkProjectModalData = () => {
    this.createFrameworkProjectModalData = {
      project: {
        mid: "",
        name: "",
        finalizationDate: moment(new Date()).format("YYYY-MM-DD"),
        projectType: "FRAMEWORK",
        projectOwners: [],
        description: "",
        isFastTrack: false,
        areBusinessConstraintsDisabled: false,
      },
      frameworkToBeCreated: {
        code: "",
        description: "",
        name: "",
        frameworkType: null,
        reportingPopulation: "",
        otherLinks: "",
        orderNo: "",
      }
    }
    this.selectedFrameworks = [];
    this.listOfFrameworksToBeCreated = [];
  }

  @action
  handleSelectedFrameworksChange = (frameworks) => {
    this.selectedFrameworks = frameworks;
  }

  @action
  handlePopulateListOfFrameworksToBeCreated = () => {
    this.listOfFrameworksToBeCreated.push(this.createFrameworkProjectModalData.frameworkToBeCreated);
    this.createFrameworkProjectModalData.frameworkToBeCreated = {
      code: "",
      name: "",
      description: "",
      frameworkType: null,
      reportingPopulation: "",
      otherLinks: "",
      orderNo: "",
    };
  }

  @action
  handleAssignementOfNewListOfFrameworks = (frameworks) => {
    this.listOfFrameworksToBeCreated = frameworks.map(framework => framework.value)
  }

  @computed
  get computed_name_and_tid_all_ma() {
    return this.arr_maintenanceAgencies.map(maintenanceAgencies => ({
      label: maintenanceAgencies.maintenanceAgency.name,
      value: maintenanceAgencies.maintenanceAgency.tid
    }));
  }

  @computed
  get isCreateFrameworkProjectModalVisible() {
    return this.createFrameworkProjectModalVisible;
  }

  @computed
  get getCreateFrameworkProjectModalData() {
    return this.createFrameworkProjectModalData;
  }

  @computed
  get getSelectedExistingFrameworks() {
    return this.selectedFrameworks;
  }

  @computed
  get getListOfFrameworksToBeCreated() {
    return this.listOfFrameworksToBeCreated.map(framework => ({"label": framework.code, "value" : framework}));
  }
}
